export default __webpack_public_path__ + "static/media/1025.b3682cee.png";